import { transformGiftingPurchaseLineItems } from '../../../../subscribers/analytics/gtm-adapter/data-transformers/purchase'
import { transformLineItemsForPayload } from '../../../../subscribers/analytics/gtm-adapter/data-transformers/core'

export const getLineItemsTransformer = (isGifting = false) =>
  isGifting === true
    ? transformGiftingPurchaseLineItems
    : transformLineItemsForPayload
